import React, { useState, useEffect } from 'react';
import '../components/Match/match.css';
import { useTranslation } from '../i18n/I18nContext';
import { OverviewTab } from '../components/Match/OverviewTab';
import { ParamsTab } from '../components/Match/ParamsTab';
import { SimulatorTab } from '../components/Match/SimulatorTab';
import { axios } from '../libs/axios';

export const Match = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState('overview');
  const [paramsProfile, setParamsProfile] = useState('default-flow');
  const [recomputing, setRecomputing] = useState(false);
  const [inquiryText, setInquiryText] = useState('');
  const [classifierCache, setClassifierCache] = useState({ text: '', results: null, key: '' });
  const [paramsSaveState, setParamsSaveState] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const data = await axios.get('/match/params');
        const def = data.defaultProfile || data.profiles?.[0];
        if (def?.name) {
          setParamsProfile(def.name);
        }
      } catch (e) {
        // keep initial profile until Params tab loads
      }
    })();
  }, []);

  const recompute = async () => {
    setRecomputing(true);
    try {
      await axios.post('/match/metrics/recompute', { paramsProfile });
      window.nSuccess?.(t('match.recomputed'));
    } catch (e) {
      window.nError?.(t('match.recomputeFailed'));
    } finally {
      setRecomputing(false);
    }
  };

  return (
    <div id="match" className="row table_v2 match-page">
      <div className="col p-0">
        <div className="x_panel chatbot-builder">
          <div className="header-menu d-flex justify-content-between align-items-center">
            <div className="header-title d-flex align-items-center">
              <h1>{t('match.title')}</h1>
            </div>
            <div className="d-flex gap-2">
              {tab === 'params' && paramsSaveState?.onSave && (
                <button
                  type="button"
                  className="btn btn-sm btn-success"
                  onClick={paramsSaveState.onSave}
                  disabled={paramsSaveState.disabled}
                >
                  {paramsSaveState.saving ? t('common.loading') : t('match.saveCurrent')}
                </button>
              )}
              <button type="button" className="btn btn-sm btn-secondary" onClick={recompute} disabled={recomputing}>
                {recomputing ? t('common.loading') : t('match.recompute')}
              </button>
            </div>
          </div>
          <div className="x_content">
            <div className="page-container d-flex flex-column">
              <div className="tab-container mb-3">
                <div className={`tab btn-section ${tab === 'overview' ? 'active' : ''}`} onClick={() => setTab('overview')}>
                  <span></span>{t('match.tabOverview')}
                </div>
                <div className={`tab btn-section ${tab === 'params' ? 'active' : ''}`} onClick={() => setTab('params')}>
                  <span></span>{t('match.tabParams')}
                </div>
                <div className={`tab btn-section ${tab === 'simulator' ? 'active' : ''}`} onClick={() => setTab('simulator')}>
                  <span></span>{t('match.tabSimulator')}
                </div>
              </div>

              <div className="page-content">
                {tab === 'overview' && <OverviewTab paramsProfile={paramsProfile} />}
                {tab === 'params' && (
                  <ParamsTab
                    onProfileChange={setParamsProfile}
                    inquiryText={inquiryText}
                    onInquiryTextChange={setInquiryText}
                    classifierCache={classifierCache}
                    onClassifierCacheChange={setClassifierCache}
                    onSaveStateChange={setParamsSaveState}
                  />
                )}
                {tab === 'simulator' && (
                  <SimulatorTab
                    paramsProfile={paramsProfile}
                    onProfileChange={setParamsProfile}
                    inquiryText={inquiryText}
                    onInquiryTextChange={setInquiryText}
                    classifierCache={classifierCache}
                    onClassifierCacheChange={setClassifierCache}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
